import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { IAdministration, IAdministrationCreate, IAdministrationUpdate } from '@tsin-core/models/administration-management';
import { environment } from '@tsin-env/environment';
import { Observable } from 'rxjs';

const ADMINISTRATION_URL = `${environment.apiUrl}/administration`;

@Injectable({
  providedIn: 'root',
})
export class AdministrationManagementService {
  constructor(private http: HttpClient) {}

  createAdministration(administration: Omit<IAdministrationCreate, 'id'>): Observable<IAdministration> {
    return this.http.post<any>(ADMINISTRATION_URL, administration);
  }

  updateAdministration(administration: Omit<IAdministrationUpdate, 'id'>): Observable<IAdministration> {
    return this.http.put<any>(ADMINISTRATION_URL, administration);
  }

  getAdministrations(): Observable<IAdministration[]> {
    return this.http.get<IAdministration[]>(ADMINISTRATION_URL);
  }

  deleteAdministration(id: string): Observable<any> {
    return this.http.delete(`${ADMINISTRATION_URL}/single/${id}`);
  }
}
